import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	heading: {
		fontWeight: '600',
		color: theme.palette.primary.main,
		margin: '0 auto !important'
	},
	loaderContainer: {
		width: '100%',
		height: '100%',
		minHeight: '25rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column'
	}
}));
